export const SORT_OPTIONS = [
  { value: 'RELEVANT', label: 'Relevant' },
  { value: 'PRICE_LOW_TO_HIGH', label: 'Price: Low to High' },
  { value: 'PRICE_HIGH_TO_LOW', label: 'Price: High to Low' },
  { value: 'DISTANCE', label: 'Distance: Close to Far' },
];

export const VEHICLE_TYPE_OPTIONS = [
  { value: 'SEDAN', label: 'Sedan' },
  { value: 'SUV', label: 'SUVs' },
  { value: 'MINIVAN', label: 'Minivans' },
  { value: 'TRUCK', label: 'Trucks' },
  { value: 'VAN', label: 'Vans' },
  { value: 'CARGO_VAN', label: 'Cargo vans' },
  { value: 'BOX_TRUCK', label: 'Box trucks' },
  { value: 'CONVERTIBLE', label: 'Convertible' },
];

export const FUEL_TYPE_OPTIONS = [
  { value: 'GASOLINE', label: 'Gasoline' },
  { value: 'HYBRID', label: 'Hybrid' },
  { value: 'ELECTRIC', label: 'Electric' },
  { value: 'DIESEL', label: 'Diesel' },
];

export const FEATURE_OPTIONS = [
  { value: 'ALL_WHEEL_DRIVE', label: 'All-wheel drive' },
  { value: 'ANDROID_AUTO', label: 'Android Auto' },
  { value: 'APPLE_CARPLAY', label: 'Apple CarPlay' },
  { value: 'AUX_INPUT', label: 'Aux input' },
  { value: 'BACKUP_CAMERA', label: 'Backup camera' },
  { value: 'BIKE_RACK', label: 'Bike rack' },
  { value: 'BLIND_SPOT_WARNING', label: 'Blind spot warning' },
  { value: 'BLUETOOTH', label: 'Bluetooth' },
  { value: 'CHILD_SEAT', label: 'Child seat' },
  { value: 'GPS', label: 'GPS' },
  { value: 'HEATED_SEATS', label: 'Heated seats' },
  { value: 'KEYLESS_ENTRY', label: 'Keyless entry' },
  { value: 'PET_FRIENDLY', label: 'Pet friendly' },
  { value: 'SKI_RACK', label: 'Ski rack' },
  { value: 'SNOW_TIRES', label: 'Snow tires' },
  { value: 'SUNROOF', label: 'Sunroof' },
  { value: 'TOLL_PASS', label: 'Toll pass' },
  { value: 'USB_CHARGER', label: 'USB charger' },
  { value: 'USB_INPUT', label: 'USB input' },
  { value: 'WHEELCHAIR_ACCESSIBLE', label: 'Wheelchair accessible' },
];

export const SEAT_OPTIONS = [
  { value: 2, label: '2 or more' },
  { value: 4, label: '4 or more' },
  { value: 5, label: '5 or more' },
  { value: 6, label: '6 or more' },
  { value: 7, label: '7 or more' },
  { value: 8, label: '8 or more' },
];

export const TRANSMISSION_OPTIONS = [
  { value: 'MANUAL', label: 'Manual' },
  { value: 'AUTOMATIC', label: 'Automatic' },
];
